import { FormInstance } from "antd/lib/form";
import { FilterOutUser } from "./filter-out-user";
import {
  Country,
  DeviceCategory,
  DeviceModal,
  ExtraInstallDate,
  ExtraOnboardingDate,
  FirstAppVersion,
  LastAppVersion,
  MediaSource,
} from "./form";
import { css } from "@emotion/react";
import { Card } from "antd";
import { ExtraPlatform } from "./form/extra-platform";
import { ExtraVariant } from "./form/extra-variants";

export const generalStyleFormExtraItem = {
  className: "w-[50%] min-w-[400px]",
  labelCol: {
    span: 8,
  },
};
const FormGroupLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="flex flex-wrap justify-around w-full">{children}</div>;
};
export const ExtraFieldModalContent: React.FC<{ form: FormInstance }> = ({ form }) => {
  return (
    <div
      css={css`
        .ant-picker-range {
          background-color: white;
        }
      `}
    >
      <FilterOutUser form={form} />
      <Card
        style={{
          boxShadow: "0 0 0 0",
        }}
        className="mb-8"
        title={<div className="flex">Dimension filters</div>}
        css={css`
          .ant-form-item {
            margin-bottom: 2;
          }
          .ant-card-head {
            background-color: #e9f6fe;
          }
          .ant-card-body {
            padding: 10;
          }
        `}
      >
        <FormGroupLayout>
          <ExtraPlatform form={form} />
          <ExtraVariant form={form} />
        </FormGroupLayout>
        <FormGroupLayout>
          <ExtraInstallDate form={form} />
          <ExtraOnboardingDate form={form} />
        </FormGroupLayout>
        <FormGroupLayout>
          <Country form={form} />
          <MediaSource form={form} />
        </FormGroupLayout>
        <FormGroupLayout>
          <DeviceModal form={form} />
          <DeviceCategory form={form} />
        </FormGroupLayout>
        <FormGroupLayout>
          <FirstAppVersion form={form} />
          <LastAppVersion form={form} />
        </FormGroupLayout>
      </Card>
    </div>
  );
};
